export default (theme: any) => ({
    twoFactorAuthPanelDetails: {
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        alignItems: 'center',
        position: 'relative'
    }
});
